import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

// Store
import {
  loadCallHistory,
  loadCallHistoryError,
  loadCallHistorySuccess,
} from './call-history.actions';
import { toggleLoaderState } from '../loader/loader.actions';

// Services
import { CallService } from '@services/call.service';

@Injectable()
export class CallHistoryEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store);
  private userCallService = inject(CallService);

  loadCallHistory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCallHistory),
      switchMap(({ page, isLoadMore = true, limit = 5 }) => {
        this.store$.dispatch(toggleLoaderState({ state: true }));

        return this.userCallService.userCalls({ page, limit }).pipe(
          map(chatHistory => {
            this.store$.dispatch(toggleLoaderState({ state: false }));
            return loadCallHistorySuccess({ chatHistory, isLoadMore });
          }),
          catchError(error => {
            this.store$.dispatch(toggleLoaderState({ state: false }));
            return of(loadCallHistoryError({ error }));
          }),
        );
      }),
    ),
  );
}
